import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'lt',
  months: [
    'sausio',
    'vasario',
    'kovo',
    'balandžio',
    'gegužės',
    'birželio',
    'liepos',
    'rugpjūčio',
    'rugsėjo',
    'spalio',
    'lapkričio',
    'gruodžio',
  ],
  monthsShort: ['saus', 'vas', 'kov', 'bal', 'geg', 'birž', 'liep', 'rugp', 'rugs', 'spal', 'lapkr', 'gruod'],
  weekdays: [
    'sekmadienis',
    'pirmadienis',
    'antradienis',
    'trečiadienis',
    'ketvirtadienis',
    'penktadienis',
    'šeštadienis',
  ],
  weekdaysMin: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
  weekdaysShort: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'YYYY [m]. MMMM D [d].',
    'LL-D': 'YYYY [m]. MMMM',
    'LL-Y': 'MMMM D [d].',
    LLL: 'YYYY [m]. MMMM D [d]., HH:mm',
    'LLL-Y': 'MMMM D [d]., HH:mm',
    LLLL: 'YYYY [m]. MMMM D [d]., dddd HH:mm',
    'LLLL-Y': 'MMMM D [d]., dddd HH:mm',
    l: 'YYYY-MM-DD',
    'l-Y': 'MM-DD',
    ll: 'YYYY-MM-DD',
    'll-Y': 'MMM D',
    'll-D': 'YYYY-MM',
    lll: 'YYYY-MM-DD, HH:mm',
    'lll-Y': 'MM-DD, HH:mm',
    llll: 'YYYY-MM-DD, ddd HH:mm',
    'llll-Y': 'MM-DD, ddd HH:mm',
    'll-Y+w': 'MM-DD, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY [m]. MMMM D [d]. HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'priešpiet', pm: 'popiet', AM: 'priešpiet', PM: 'popiet' },
  past: {
    y: { one: 'prieš %s m.', few: 'prieš %s m.', many: 'prieš %s m.', other: 'prieš %s m.' },
    M: { one: 'prieš %s mėn.', few: 'prieš %s mėn.', many: 'prieš %s mėn.', other: 'prieš %s mėn.' },
    w: { one: 'prieš %s sav.', few: 'prieš %s sav.', many: 'prieš %s sav.', other: 'prieš %s sav.' },
    d: { one: 'prieš %s d.', few: 'prieš %s d.', many: 'prieš %s d.', other: 'prieš %s d.' },
    h: { one: 'prieš %s val.', few: 'prieš %s val.', many: 'prieš %s val.', other: 'prieš %s val.' },
    m: { one: 'prieš %s min.', few: 'prieš %s min.', many: 'prieš %s min.', other: 'prieš %s min.' },
    s: { one: 'prieš %s sek.', few: 'prieš %s sek.', many: 'prieš %s sek.', other: 'prieš %s sek.' },
  },
  future: {
    y: { one: 'po %s m.', few: 'po %s m.', many: 'po %s m.', other: 'po %s m.' },
    M: { one: 'po %s mėn.', few: 'po %s mėn.', many: 'po %s mėn.', other: 'po %s mėn.' },
    w: { one: 'po %s sav.', few: 'po %s sav.', many: 'po %s sav.', other: 'po %s sav.' },
    d: { one: 'po %s d.', few: 'po %s d.', many: 'po %s d.', other: 'po %s d.' },
    h: { one: 'po %s val.', few: 'po %s val.', many: 'po %s val.', other: 'po %s val.' },
    m: { one: 'po %s min.', few: 'po %s min.', many: 'po %s min.', other: 'po %s min.' },
    s: { one: 'po %s sek.', few: 'po %s sek.', many: 'po %s sek.', other: 'po %s sek.' },
  },
  pastLong: {
    y: { one: 'prieš %s metus', few: 'prieš %s metus', many: 'prieš %s metų', other: 'prieš %s metų' },
    M: { one: 'prieš %s mėnesį', few: 'prieš %s mėnesius', many: 'prieš %s mėnesio', other: 'prieš %s mėnesių' },
    w: { one: 'prieš %s savaitę', few: 'prieš %s savaites', many: 'prieš %s savaitės', other: 'prieš %s savaičių' },
    d: { one: 'prieš %s dieną', few: 'prieš %s dienas', many: 'prieš %s dienos', other: 'prieš %s dienų' },
    h: { one: 'prieš %s valandą', few: 'prieš %s valandas', many: 'prieš %s valandos', other: 'prieš %s valandų' },
    m: { one: 'prieš %s minutę', few: 'prieš %s minutes', many: 'prieš %s minutės', other: 'prieš %s minučių' },
    s: { one: 'prieš %s sekundę', few: 'prieš %s sekundes', many: 'prieš %s sekundės', other: 'prieš %s sekundžių' },
  },
  futureLong: {
    y: { one: 'po %s metų', few: 'po %s metų', many: 'po %s metų', other: 'po %s metų' },
    M: { one: 'po %s mėnesio', few: 'po %s mėnesių', many: 'po %s mėnesio', other: 'po %s mėnesių' },
    w: { one: 'po %s savaitės', few: 'po %s savaičių', many: 'po %s savaitės', other: 'po %s savaičių' },
    d: { one: 'po %s dienos', few: 'po %s dienų', many: 'po %s dienos', other: 'po %s dienų' },
    h: { one: 'po %s valandos', few: 'po %s valandų', many: 'po %s valandos', other: 'po %s valandų' },
    m: { one: 'po %s minutės', few: 'po %s minučių', many: 'po %s minutės', other: 'po %s minučių' },
    s: { one: 'po %s sekundės', few: 'po %s sekundžių', many: 'po %s sekundės', other: 'po %s sekundžių' },
  },
  abbr: {
    y: { one: '%s m.', other: '%s m.' },
    M: { one: '%s mėn.', other: '%s mėn.' },
    w: { one: '%s sav.', other: '%s sav.' },
    d: { one: '%s d.', other: '%s d.' },
    h: { one: '%s val.', other: '%s val.' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s metai', few: '%s metai', many: '%s metų', other: '%s metų' },
    M: { one: '%s mėnuo', few: '%s mėnesiai', many: '%s mėnesio', other: '%s mėnesių' },
    w: { one: '%s savaitė', few: '%s savaitės', many: '%s savaitės', other: '%s savaičių' },
    d: { one: '%s diena', few: '%s dienos', many: '%s dienos', other: '%s dienų' },
    h: { one: '%s valanda', few: '%s valandos', many: '%s valandos', other: '%s valandų' },
    m: { one: '%s minutė', few: '%s minutės', many: '%s minutės', other: '%s minučių' },
    s: { one: '%s sekundė', few: '%s sekundės', many: '%s sekundės', other: '%s sekundžių' },
  },
  justNow: 'ką tik',
  yesterday: 'vakar',
  today: 'šiandien',
  tomorrow: 'rytoj',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'YYYY [m]. MMMM D [d].', end: 'YYYY [m]. MMMM D [d].' },
    'yl-1': { start: 'MMMM D [d].', end: 'YYYY [m]. MMMM D [d].' },
    ml: { start: 'MMMM D [d].', end: 'MMMM D [d].' },
    'ml-1': { start: 'YYYY MMMM D', end: 'D' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'YYYY MMM D', end: 'YYYY MMM D' },
    'y-1': { start: 'YYYY MMM D', end: 'MMM D' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'YYYY MMM D', end: 'D' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'YYYY MMM D, ddd', end: 'YYYY MMM D, ddd' },
    'Y-1': { start: 'YYYY MMM D, ddd', end: 'MMM D, ddd' },
    M: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    D: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    yt: { start: 'YYYY MMM D HH:mm', end: 'YYYY MMM D HH:mm' },
    mt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    dt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY MMM D HH:mm', end: 'YYYY MMM D HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'lt';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'priešpiet' : 'priešpiet';
    } else {
      return isLowerCase ? 'popiet' : 'popiet';
    }
  },
};
